module.exports = __webpack_public_path__ + "static/media/banner_Aviator-jetx.c211b31b.png";